"use client";

import { useExitAnimation } from "@/app/hooks/useExitAnimation";

interface Props {
  label: string;
  selected: string[];
  values: string[];
  isOpen: boolean;
  onToggle: () => void;
  onToggleValue: (val: string) => void;
}

export default function AttrDropdown({ label, selected, values, isOpen, onToggle, onToggleValue }: Props) {
  const dropdown = useExitAnimation(isOpen);

  return (
    <div className="relative">
      <button
        onClick={onToggle}
        className={`flex items-center gap-1 px-2.5 text-xs h-5 border rounded-md transition-colors ${selected.length > 0 ? "border-transparent" : "border-gray-200 text-gray-600"}`}
        style={selected.length > 0 ? { background: "var(--chip-bg)", color: "var(--chip-color)", borderColor: "transparent" } : {}}
        onMouseEnter={e => { if (!selected.length) (e.currentTarget as HTMLElement).style.background = "var(--dropdown-hover)"; }}
        onMouseLeave={e => { if (!selected.length) (e.currentTarget as HTMLElement).style.background = ""; }}
      >
        {label}
        {selected.length > 0 && (
          <span className="rounded-full px-1.5 text-[10px] leading-4" style={{ background: "var(--chip-color)", color: "var(--chip-bg)" }}>{selected.length}</span>
        )}
        <span className="text-[14px]" style={{ color: "var(--table-header-text)" }}>▾</span>
      </button>
      {dropdown.mounted && (
        <div
          className="ui-popover-panel ui-popover-panel-left ui-dropdown-panel absolute top-full left-0 mt-1 min-w-[160px] z-50 max-h-52 overflow-y-auto"
          data-state={dropdown.state}
        >
          {values.length === 0 && <div className="px-3 py-2 text-xs" style={{ color: "var(--table-header-text)" }}>Нет данных</div>}
          {values.map(v => (
            <button
              key={v}
              onClick={() => onToggleValue(v)}
              className="ui-dropdown-item"
              style={{ color: selected.includes(v) ? "var(--chip-color)" : "var(--text-secondary)" }}
            >
              <span className="w-3.5 h-3.5 border rounded flex items-center justify-center shrink-0" style={selected.includes(v) ? { background: "var(--chip-bg)", borderColor: "var(--chip-color)" } : { borderColor: "var(--input-border)" }}>
                {selected.includes(v) && <span className="text-[8px]" style={{ color: "var(--chip-color)" }}>✓</span>}
              </span>
              {v}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
